export default [
  ...applyRules(['guest'], [
    {
      path: '/',
      component: () => import('../layouts/AuthLayout.vue'),
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('../views/auth/Index.vue')
        },
        {
          path: '/recovery_password/:code',
          name: 'recovery_password',
          component: () => import('../views/auth/RecoveryPassword.vue')
        }
      ]
    }
  ]),
  ...applyRules(['auth'], [
    {
      path: '/settings',
      component: () => import('../layouts/WrapperLayout.vue'),
      children: [
        {
          path: '',
          name: 'settings',
          component: () => import('../views/settings/Index.vue')
        },
        {
          path: 'privacy-political',
          name: 'settings-privacy-political',
          component: () => import('../views/settings/PolicyPolitical.vue')
        }
      ]
    },
    {
      path: '/choose-business',
      component: () => import('../layouts/WrapperLayout.vue'),
      children: [
        {
          path: '',
          name: 'choose-business',
          component: () => import('../views/dashboard/ChooseBusiness.vue')
        }
      ]
    },
    {
      path: '/solicitudes',
      component: () => import('../layouts/SolicitudLayout.vue'),
      children: [
        // Pantalla inicial Dashboard
        {
          path: '',
          name: 'indexSolicitud',
          component: () => import('../views/solicitud/Solicitud.vue')
        },
        {
          path: 'search',
          name: 'searchSolicitud',
          component: () => import('../views/solicitud/BuscarSolicitud.vue')
        },
      ]
    },
    {
      path: '/autorizaciones',
      component: () => import('../layouts/AutorizadorLayout.vue'),
      children: [
        // Pantalla inicial Dashboard
        {
          path: '',
          name: 'indexAutorizador',
          component: () => import('../views/autorizador/Autorizador.vue')
        },
        {
          path: 'searchAutorizar',
          name: 'searchAutorizar',
          component: () => import('../views/autorizador/BuscarAutorizar.vue')
        },
      ]
    },
    {
      path: '/revisor',
      component: () => import('../layouts/RevisorLayout.vue'),
      children: [
        // Pantalla inicial Dashboard
        {
          path: '',
          name: 'indexRevisor',
          component: () => import('../views/revisor/Revisor.vue')
        },
        {
          path: 'search-revisor',
          name: 'searchRevisar',
          component: () => import('../views/revisor/BuscarRevisar.vue')
        },
      ]
    },
    {
      path: '/aprobador',
      component: () => import('../layouts/AprobadorLayout.vue'),
      children: [
        // Pantalla inicial Dashboard
        {
          path: '',
          name: 'indexAprobador',
          component: () => import('../views/aprobador/Aprobador.vue')
        },
        {
          path: 'search-aprobador',
          name: 'searchAprobar',
          component: () => import('../views/aprobador/BuscarAprobar.vue')
        },
      ]
    },
    {
      path: '/presidencia',
      component: () => import('../layouts/PresidenciaLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexPresidencia',
          component: () => import('../views/presidencia/Presidencia.vue')
        }
      ]
    },
    // GLOBAL ROUTES
    {
      path: '/global/usuario',
      component: () => import('../layouts/global/UsuarioLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexGlobalUsuario',
          component: () => import('../views/global/usuario/GlobalUsuario.vue')
        }
      ]
    },
    {
      path: '/global/autorizar',
      component: () => import('../layouts/global/AutorizarLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexGlobalAutorizar',
          component: () => import('../views/global/autorizacion/GlobalAutorizar.vue')
        }
      ]
    },
    {
      path: '/global/aprobador_parcial',
      component: () => import('../layouts/global/AprobadorParcialLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexGlobalAprobadorParcial',
          component: () => import('../views/global/aprobador_parcial/GlobalAprobadorParcial.vue')
        }
      ]
    },
    {
      path: '/global/aprobar_rendiciones',
      component: () => import('../layouts/global/AprobarRendicionLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexGlobalAprobarRendiciones',
          component: () => import('../views/global/aprobar_rendiciones/GlobalAprobarRendiciones.vue')
        }
      ]
    },
    {
      path: '/global/pendientes',
      component: () => import('../layouts/global/PendientesLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexGlobalPendientes',
          component: () => import('../views/global/pendientes/GlobalPendientes.vue')
        }
      ]
    },
    {
      path: '/global/revisor',
      component: () => import('../layouts/global/RevisorLayout.vue'),
      children: [
        {
          path: '',
          name: 'indexGlobalRevisor',
          component: () => import('../views/global/revisor/GlobalRevisar.vue')
        }
      ]
    },
    // REPORTES PRESIDENCIA
    {
      path: '/reportes',
      component: () => import('../layouts/reportes/TipoCompraLayout.vue'),
      redirect: { name: 'ReportesTipoCompra'},
      children: [
        {
          path: 'tipos-compra',
          name: 'ReportesTipoCompra',
          component: () => import('../views/reportes/TipoCompra.vue')
        }
      ]
    },
    {
      path: '/403',
      name: '403',
      component:() => import('../views/common/403.vue')
    }
  ]),
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'indexSolicitud' } 
  }
]

function applyRules(rules, routes) {
  for (let i in routes) {
    routes[i].meta = routes[i].meta || {}

    if (!routes[i].meta.rules) {
      routes[i].meta.rules = []
    }
    routes[i].meta.rules.unshift(...rules)

    if (routes[i].children) {
      routes[i].children = applyRules(rules, routes[i].children)
    }
  }

  return routes
}